export interface Point {
  t: number; // years
  value: number; // money
}

export interface Series {
  id: string;
  points: Point[];
}

/** Sample a balance function at integer years 0..years inclusive. */
export function yearlySeries(id: string, balanceAt: (t: number) => number, years: number): Series {
  const points: Point[] = [];
  for (let t = 0; t <= years; t++) {
    points.push({ t, value: balanceAt(t) });
  }
  return { id, points };
}
